<template>
  <div id="page_trade" data-role="page">
    <header class="pageHeader">
      <div class="pageHeader_img">
        <div class="content">
          <h2 class="pageHeader_title">ユーザー間売買</h2>
        </div>
      </div>
    </header>
    <section class="commingsoon">
      <div class="commingsoon_wrap">
        <h3 class="commingsoon_title">Comming soon!</h3>
        <p class="commingsoon_text">
          ユーザー間売買では、保有する楽曲権利をユーザー同士で売買することができます。<br />
          コンテンツ開始までもうしばらくお待ち下さい。
        </p>
        <div class="commingsoon_link">
          <router-link to="/" class="button-main">
            Hexabid トップページへ
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
